export default __webpack_public_path__ + "images/R5.465be06.png";